import MobileNavigation from "./MobileNavigation";
import Navigation from "./Navigation";

const NavBar = ({ setIsOpen, open, isLoggedIn, user }) => {
  return (
    <>
      <Navigation setIsOpen={setIsOpen} isLoggedIn={isLoggedIn} user={user} />
      <MobileNavigation
        open={open}
        setIsOpen={setIsOpen}
        isLoggedIn={isLoggedIn}
        user={user}
      />
    </>
  );
};

export default NavBar;
